export interface ShareMetadata {
  title: string;
  description: string;
  pathname?: string;
}

function upsertMeta(selector: string, attribute: string, value: string): void {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement('meta');
    const separator = attribute.indexOf(':');
    const name = attribute.slice(0, separator);
    const key = attribute.slice(separator + 1);
    element.setAttribute(name, key);
    document.head.append(element);
  }
  element.content = value;
}

export function setShareMetadata(metadata: ShareMetadata): void {
  const url = new URL(
    metadata.pathname ?? window.location.pathname,
    window.location.origin,
  ).toString();
  document.title = `${metadata.title} | Conference Study`;
  upsertMeta('meta[name="description"]', 'name:description', metadata.description);
  upsertMeta('meta[property="og:title"]', 'property:og:title', metadata.title);
  upsertMeta(
    'meta[property="og:description"]',
    'property:og:description',
    metadata.description,
  );
  upsertMeta('meta[property="og:url"]', 'property:og:url', url);

  let canonical = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.append(canonical);
  }
  canonical.href = url;
}

export function createShareButton(
  label: string,
  pathname: string,
  title: string,
): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'button button--secondary';
  button.textContent = label;
  button.addEventListener('click', () => {
    const url = new URL(pathname, window.location.origin).toString();
    void (async () => {
      try {
        await navigator.clipboard.writeText(url);
        button.textContent = 'Link copied';
      } catch {
        button.textContent = `${title}: ${url}`;
      }
    })();
  });
  return button;
}
